import * as React from "react";
import {Button, Card, Form, Grid, Input, Image, TextArea} from "semantic-ui-react";
import coreState, {ICoreState} from "../../common/CoreState";
import {UtilityManager} from "../../../core/utility/UtilityManager";
import {StateManager} from "../../../core/utility/StateManager";
import {IApiResponseDto} from "../../../core/dto/common/ApiResponseDto";
import {IFileRequest} from "../../../core/api/common/request/FileRequest";
import FileBase64 from 'react-file-base64';
import {ConfirmationDialog} from "../../common/ConfirmationDialog";
import {IReadPostResponse} from "../../../core/api/post/response/ReadPostResponse";
import {PostApiService} from "../../../core/api/post/PostApiService";
import {IUpdatePostRequest} from "../../../core/api/post/request/UpdatePostRequest";

interface IProps {
    id: string;
    onSuccessRequest(): void;
    onCancelForm(): void;
}

interface IState {
    data: IReadPostResponse;
    coreState: ICoreState;
    imageRequest: IFileRequest | undefined;
    confirmationDialog: JSX.Element;
}

export class DetailPost extends React.Component<IProps, IState> {

    private readonly apiService = new PostApiService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            data: {
                dateTime: new Date(),
                description: '',
                image: '',
                tag: '',
                title: ''
            },
            coreState,
            imageRequest: undefined,
            confirmationDialog: <div/>
        }
    }

    public componentDidMount = () => {
        UtilityManager.scrollToEl('post-detail');
        this.readData();
    };

    public render() {

        return (
            <div id="post-detail">
                <Card fluid={true}>
                    <Card.Content>
                        <Card.Header>Detail Data</Card.Header>
                    </Card.Content>
                    <Card.Content>
                        {this.state.coreState.isLoading && this.state.coreState.loadingNotification}
                        {this.state.confirmationDialog}
                        <Grid verticalAlign='middle'>
                            <Grid.Row>
                                <Grid.Column width={4} />
                                <Grid.Column width={9}>
                                    {this.state.coreState.errorNotification}
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                        <Form size='large' onSubmit={this.submitData} loading={this.state.coreState.isLoading}>
                            <Grid verticalAlign='middle'>

                                <Grid.Row>
                                    <Grid.Column width={4}>
                                        <label style={{ float: 'right' }}>Judul</label>
                                    </Grid.Column>
                                    <Grid.Column width={9}>
                                        <Input
                                            name="title" id="title"
                                            value={this.state.data.title}
                                            onChange={this.formListener}
                                            fluid={true} />
                                    </Grid.Column>
                                </Grid.Row>

                                <Grid.Row>
                                    <Grid.Column width={4}>
                                        <label style={{ float: 'right' }}>Deskripsi</label>
                                    </Grid.Column>
                                    <Grid.Column width={9}>
                                        <TextArea
                                            rows={'10'}
                                            name="description" id="description"
                                            value={this.state.data.description}
                                            onChange={this.formListener}
                                            fluid={true} />
                                    </Grid.Column>
                                </Grid.Row>

                            </Grid>

                            <Grid verticalAlign='middle'>
                                <Grid.Row>
                                    <Grid.Column width={4}>
                                        <label style={{ float: 'right' }}>Tanggal</label>
                                    </Grid.Column>
                                    <Grid.Column width={9}>
                                        <Input
                                            type="date"
                                            name="dateTime" id="dateTime"
                                            value={this.state.data.dateTime}
                                            onChange={this.formListener}
                                            fluid={true} />
                                    </Grid.Column>
                                </Grid.Row>

                                <Grid.Row>
                                    <Grid.Column width={4}>
                                        <label style={{ float: 'right' }}>Tag</label>
                                    </Grid.Column>
                                    <Grid.Column width={9}>
                                        <Input
                                            disabled={true}
                                            name="tag" id="tag"
                                            value={this.state.data.tag}
                                            onChange={this.formListener}
                                            fluid={true} />
                                    </Grid.Column>
                                </Grid.Row>

                                <Grid.Row>
                                    <Grid.Column width={4}>
                                        <label style={{ float: 'right' }}>Gambar</label>
                                    </Grid.Column>
                                    <Grid.Column width={9}>
                                        <Image src={this.state.data.image} size='small' />
                                        <FileBase64
                                            multiple={false}
                                            onDone={this.imageFormListener} />
                                    </Grid.Column>
                                </Grid.Row>

                                <Grid.Column floated='right' width={12}>
                                    <Button type='submit' primary={true}>Ubah</Button>
                                    <Button type='button' color="red" onClick={this.deleteConfirmationDialog}>Hapus</Button>
                                    <Button type='button' onClick={this.props.onCancelForm}>Batal</Button>
                                </Grid.Column>
                            </Grid>

                        </Form>
                    </Card.Content>
                </Card>

            </div>
        );
    }

    private submitData = (e: any) => {

        this.setState({
            coreState: StateManager.setOnLoading(this.state.coreState)
        });

        const updateRequest: IUpdatePostRequest = {
            description: this.state.data.description,
            dateTime: this.state.data.dateTime,
            imageFile: undefined,
            tag: this.state.data.tag,
            title: this.state.data.title
        };

        if(this.state.imageRequest !== undefined){
            updateRequest.imageFile = this.state.imageRequest;
        }

        this.apiService.update(this.props.id, updateRequest)
            .then((data: IApiResponseDto) => {

                this.setState({
                    coreState: StateManager.setOffLoading(this.state.coreState)
                });

                this.props.onSuccessRequest();

            }).catch((error: IApiResponseDto) => {

            this.setState({
                coreState: StateManager.showErrorNotification(this.state.coreState, error.errorMessage)
            });

        });

        e.preventDefault();
    };

    private formListener = (e: any) => {
        const field = e.target.name;
        const value = e.target.value;

        this.setState(prevState => ({
            data:
                {
                    ...prevState.data,
                    [field]: value
                }
        }));
    };

    private readData = () => {

        this.setState({
            coreState: StateManager.setOnLoading(this.state.coreState)
        });

        this.apiService.read(this.props.id)
            .then((data: IApiResponseDto) => {

                this.setState({
                    coreState: StateManager.setOffLoading(this.state.coreState),
                    data: data.result
                });

            }).catch((error: IApiResponseDto) => {
            this.setState({
                coreState: StateManager.showErrorNotification(this.state.coreState, error.errorMessage)
            });

        });

    };

    private imageFormListener = (response: any) => {
        const result: IFileRequest = {
            name: response.name,
            base64: response.base64,
            size: response.file.size,
            type: response.type

        };

        const data = this.state.data;
        data.image = response.base64;

        this.setState({
            imageRequest: result,
            data
        });
    };

    private deleteConfirmationDialog = () => {
        this.setState({
            confirmationDialog: <ConfirmationDialog
                continueAction={this.deleteData}
                cancelAction={this.hideConfirmationDialog}
                title={'Informasi'}
                description={'Data akan dihapus dan tidak bisa dikembalikan. Lanjutkan?'}/>
        })
    };

    private deleteData = () =>{

        this.apiService.delete(this.props.id)
            .then((data: IApiResponseDto) => {

                this.props.onSuccessRequest();

            }).catch((error: IApiResponseDto) => {
            this.setState({
                coreState: StateManager.showErrorNotification(this.state.coreState, error.errorMessage)
            });

        });

    };

    private hideConfirmationDialog = () =>{
        this.setState({
            confirmationDialog: <div/>
        })
    };

}


// WEBPACK FOOTER //
// ./src/component/admin/post/DetailPost.tsx